import React, { useState, useEffect, useMemo } from "react";
import { Table, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import ExportToExcel from "../../../../../components/ExportToExcel";
import Pagination from "../../../../../components/Pagination";
import SearchBar from "../../../../../components/SearchBar";
import moment from "moment";
import PayrollFilter from "./PayrollFilter";
import Select from "react-select";
import { FaSpinner } from "react-icons/fa";
import RujulColumnFilter from "../../../../../components/RujulColumnFilter";

const CalculatePayrollComponent = ({
  data,
  dataSets,
  handleReset,
  isSubmitStatus,
  columnHeadersMap,
  columns,
  selectedResource,
  selectAllChecked,
  isApiStatus,
  isRequiredStatus,
  checkBoxRequiredMap,
  searchTerm,
  setSearchTerm,
  isFilterRequired,
  formDatas,
  handleGetData,
  handleChange,
  filterFormData,
  handleCheckboxChange,
  formattedKeys,
  totals,
  handleSubmitButton,
  handleSelectAllChange,
  editableColumn,
  handleEditableColumnChange,
  handleTDSCalculate,
  handleApprovedByChange,
  ApprovedBYOptions,
  userName,
  hanldeLinkColumn,
  SendIssueMail,
}) => {

  const [rujulDataSet, setRujulDataset] = useState([])

  useEffect(() => {
    setRujulDataset(dataSets[activeTab])
  }, [dataSets])
  const datasetKeys = Object.keys(dataSets);
  const [activeTab, setActiveTab] = useState(Object.keys(dataSets)[0]);

  const datasetKeysColumnFilter = Object.keys(dataSets[activeTab]);

  // Get columns only for the active tab
  const colummmm = (columnHeadersMap[activeTab] || []).map((el) => ({
    label: el?.label,
    value: el?.key
  }));

  console.log("colummmm", colummmm);


  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [editingIndex, setEditingIndex] = useState(null);
  const [visibleColumns, setVisibleColumns] = useState({});
  const [showConfirm, setShowConfirm] = useState(false);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");

  // Debounce search term
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 300);
    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  useEffect(() => {
    setCurrentPage(1);
  }, [debouncedSearchTerm, activeTab]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };


  const [filteredData, setFilteredData] = useState(null);


  // Modify your data filtering logic
  const displayedData = useMemo(() => {
    // Use filteredData if it exists, otherwise use the original dataset
    const datasetToFilter = filteredData || dataSets[activeTab] || [];

    if (!debouncedSearchTerm) return datasetToFilter;

    return datasetToFilter.filter((item) =>
      Object.values(item).some((value) =>
        String(value).toLowerCase().includes(debouncedSearchTerm.toLowerCase())
      )
    );
  }, [dataSets, activeTab, debouncedSearchTerm, filteredData]);

  // Update all references from sortedData to displayedData
  const sortedData = useMemo(() => {
    if (!sortConfig.key || !Array.isArray(displayedData)) return displayedData;

    return [...displayedData].sort((a, b) => {
      const valA = a[sortConfig.key] ? String(a[sortConfig.key]) : "";
      const valB = b[sortConfig.key] ? String(b[sortConfig.key]) : "";

      if (sortConfig.direction === "ascending") {
        return valA.localeCompare(valB);
      } else {
        return valB.localeCompare(valA);
      }
    });
  }, [displayedData, sortConfig]);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, sortedData.length);
  const currentData = sortedData.slice(startIndex, endIndex);

  const recordsPerPageOption = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: sortedData.length, label: "All" },
  ];

  const [selectedRecordsPerPage, setSelectedRecordsPerPage] = useState(10);
  const totalPages = Math.ceil(sortedData.length / selectedRecordsPerPage);

  const handleRecordsPerPage = (e) => {
    const newRecordsPerPage = Number(e.target.value);
    const currentStartIndex = (currentPage - 1) * selectedRecordsPerPage;
    const newPage = Math.floor(currentStartIndex / newRecordsPerPage) + 1;
    setSelectedRecordsPerPage(newRecordsPerPage);
    setCurrentPage(newPage);
    setItemsPerPage(newRecordsPerPage);
  };

  const requestSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  useEffect(() => {
    const dropdownElements = document.querySelectorAll(".dropdown-toggle");
    dropdownElements.forEach((dropdown) => {
      new window.bootstrap.Dropdown(dropdown);
    });
  }, []);




  return (
    <div className="container-fluid">
      <div className="row d-flex justify-content-between align-items-center">
        <div className="col-md-6 d-flex align-items-center">
          <div className="me-2 mt-3">
            <SearchBar
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              columns={columnHeadersMap[activeTab] || []}
            />
          </div>
          {isFilterRequired && (
            <div className="dropdown">
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip id="tooltip-bottom">Filters</Tooltip>}
              >
                <button
                  className="dropdown-toggle"
                  type="button"
                  id="excel-btn"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bi bi-funnel-fill"></i>
                </button>
              </OverlayTrigger>
              <div>
                <PayrollFilter
                  formData={formDatas || []}
                  handleChange={handleChange}
                  handleReset={handleReset}
                  handleGetData={handleGetData}
                  filterFormData={filterFormData}
                />
              </div>
            </div>
          )}
        </div>

        <div className="col-md-6 d-flex justify-content-end align-items-center">
          <div className="me-3 mt-3">
            <div className="dropdown">
              <OverlayTrigger
                placement="right"
                overlay={<Tooltip id="tooltip-bottom">Filters</Tooltip>}
              >
                <button
                  className="dropdown-toggle"
                  type="button"
                  id="excel-btn"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bi bi-funnel-fill"></i>
                </button>
              </OverlayTrigger>
              <div>
                <RujulColumnFilter
                  columnOptions={colummmm}
                  columnHeadersMap={columnHeadersMap}
                  dataSets={rujulDataSet}
                  onFilterApplied={(filteredData) => {
                    setFilteredData(filteredData); // Store filtered data in state
                  }}
                  datasetKey="Calculate Payroll"
                />
              </div>
            </div>
          </div>
          <div className="me-3" style={{ minWidth: "250px", width: "40%" }}>
            <label className="form-label d-block">Executive</label>
            <Select
              options={ApprovedBYOptions}
              onChange={(selectedOptions) => handleApprovedByChange(selectedOptions)}
              value={ApprovedBYOptions?.find((o) => o.value === userName)}
              isDisabled={true}
            />
          </div>
          <div className="d-flex align-items-center mt-3">
            <button
              className="custom-btn me-3"
              onClick={(e) => handleTDSCalculate(e)}
            >
              TDS
            </button>
             <button
                className="custom-btn me-3"
                onClick={() => setShowConfirm(true)}
              >
                Send Mail
              </button>
              {showConfirm && (
                  <>
                    <div className="popup-overlay">
                      <div className="popup-box">
                        <h5>Are you sure you want to Send Mail?</h5>

                        <div className="popup-buttons">
                          <button
                            className="btn-no"
                            onClick={() => setShowConfirm(false)}
                          >
                            No
                          </button>

                          <button
                            className="btn-yes"
                            onClick={(e) => {
                              setShowConfirm(false);
                              SendIssueMail(e);
                            }}
                          >
                            Yes
                          </button>
                        </div>
                      </div>
                    </div>

                    <style jsx>{`
                      .popup-overlay {
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background: rgba(0, 0, 0, 0.5);
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        z-index: 9999;
                      }

                      .popup-box {
                        background: #fff;
                        padding: 35px 30px;
                        border-radius: 14px;
                        width: 335px; /* increased width */
                        max-width: 90%;
                        text-align: center;
                        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
                        animation: popupFade 0.25s ease-in-out;
                      }

                      .popup-box h5 {
                        margin-bottom: 25px;
                        font-size: 18px;
                        font-weight: 600;
                        color: #333;
                      }

                      .popup-buttons {
                        display: flex;
                        justify-content: center;
                        gap: 15px;
                      }

                      .btn-no {
                        padding: 6px 18px; /* slightly bigger button */
                        border-radius: 6px;
                        border: 1px solid #ccc;
                        color: #fff;
                        background-color: var(--primary-color);
                        font-size: 14px;
                        cursor: pointer;
                        transition: all 0.2s;
                      }

                      .btn-yes {
                        padding: 6px 18px; /* slightly bigger button */
                        border-radius: 6px;
                        background-color: var(--primary-color);
                        border: none;
                        color: #fff;
                        font-size: 14px;
                        cursor: pointer;
                        transition: all 0.2s;
                      }

                      @keyframes popupFade {
                        from {
                          opacity: 0;
                          transform: scale(0.9);
                        }
                        to {
                          opacity: 1;
                          transform: scale(1);
                        }
                      }
                    `}</style>
                  </>
                )}
           
            {userName && (
              <button
                className="custom-btn"
                onClick={handleSubmitButton}
                disabled={isSubmitStatus}              >
                {isSubmitStatus ? <FaSpinner className="sm-spinner" /> : "Submit"}
              </button>

            )}
          </div>
        </div>
      </div>

      <div className="m-0">
        <div className="m-0 p-0">
          <ul className="nav nav-tabs">
            {datasetKeys?.map((key, index) => (
              <li className="nav-item" key={index}>
                <button
                  className={`nav-link ${activeTab === key ? "active" : ""}`}
                  onClick={() => setActiveTab(key)}
                >
                  {key}
                </button>
              </li>
            ))}
          </ul>

          <div className="tab-content mt-3">
            {datasetKeys.map((key, index) => {
              const columnHeaders = columnHeadersMap[key] || [];

              const columnEditableHeaders = editableColumn || [];

              return (
             <div 
  key={index}
  className={`table-responsive tab-pane fade ${activeTab === key ? "show active" : ""}`}
  style={{
    maxHeight: '500px',
    overflow: 'auto',
    position: 'relative'
  }}
>
  <Table striped bordered hover style={{
    width: 'max-content', // Changed from 'auto' to 'max-content'
    minWidth: '100%',
    tableLayout: 'fixed'
  }}>
    {/* Sticky Header */}
    <thead className="text-center" id="thcolor" style={{
      position: 'sticky',
      top: 0,
      zIndex: 3,
      // backgroundColor: 'white'
    }}>
      <tr>
        {checkBoxRequiredMap[key] && (
          <th style={{
            width: "25px",
            minWidth: "25px",
            position: 'sticky',
            left: 0,
            zIndex: 4,
            // backgroundColor: 'white'
          }}>
            <input
              className="form-check-input"
              type="checkbox"
              checked={selectAllChecked}
              onChange={(e) => handleSelectAllChange(e)}
            />
          </th>
        )}
        
        {columnHeaders.map((col, i) => (
          <th
            key={i}
            style={{
              width: "80px",
              minWidth: col.label === "Employee" ? "131px" : "80px",
              position: i < 2 ? 'sticky' : 'static',
              left: i === 0 ? (checkBoxRequiredMap[key] ? '25px' : '0') :
                    i === 1 ? (checkBoxRequiredMap[key] ? '105px' : '80px') : 'auto',
              zIndex: i < 2 ? 4 : 3,
              // backgroundColor: 'white'
            }}
          >
            {col.label}
          </th>
        ))}
      </tr>
    </thead>

                      {isRequiredStatus && (
                        isApiStatus === 200 && sortedData.length !== 0 ? (
                          <tbody>
                            {sortedData.map((row, i) => (
                              <tr
                                key={i}
                                style={{
                                  backgroundColor: selectedResource?.find(o => o.ContactID === row.ContactID)
                                    ? '#e6f7ff'  // Light blue background for selected rows
                                    : 'transparent'
                                }}
                              >
                                {checkBoxRequiredMap[key] && (
                                  <td style={{
                                    width: "25px",
                                    minWidth: "25px",
                                    maxWidth: "25px",
                                    textAlign: "center",
                                    position: 'sticky',
                                    left: 0,
                                    zIndex: 1,
                                    // backgroundColor: 'white' // Match your row color
                                  }}>
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      checked={!!selectedResource?.find(
                                        (o) => o.ContactID === row.ContactID
                                      )}
                                      onChange={(e) =>
                                        handleCheckboxChange(e, row.ContactID, row)
                                      }
                                    />
                                  </td>
                                )}
                                {columnHeaders.map((col, j) => (
                                  <OverlayTrigger
                                    key={col.key}
                                    placement="bottom"
                                    overlay={
                                      <Tooltip id={`tooltip-${col.key}`}>
                                        {row[col.key]}
                                      </Tooltip>
                                    }
                                  >
                                    <td
                                      className={col.key !== "Employee" && col.key !== "EmployeeCode" && col.key !== "EmployeeName" ? "text-end" : "text-start"}
                                      key={j}
                                      onClick={() =>
                                        editableColumn.some((o) => o.key === col.key) &&
                                        setEditingIndex({
                                          rowIndex: i + startIndex, // Account for pagination
                                          colKey: col.key,
                                        })
                                      }
                                      style={{
                                        cursor: editableColumn.some(
                                          (o) => o.key === col.key
                                        )
                                          ? "pointer"
                                          : "default",
                                        backgroundColor:
                                          editableColumn.some(
                                            (o) => o.key === col.key
                                          )
                                            ? "#9696A3"
                                            : j < 3 ? 'white' : "transparent",
                                        width: "80px",
                                        minWidth: col.label === "Employee" ? "131px" : "80px",
                                        maxWidth: "80px",
                                        textAlign: col.key !== "Employee" ? "right" : "left",
                                        whiteSpace: "nowrap",
                                        borderRight: "1px solid #ddee2e6",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        backgroundColor: selectedResource?.find(o => o.ContactID === row.ContactID)
                                          ? '#e6f7ff'  // Light blue background for selected rows
                                          : "",

                                        position: j < 2 ? 'sticky' : 'static',
                                        left: j === 0 ? (checkBoxRequiredMap[key] ? '25px' : '0') :
                                          j === 1 ? (checkBoxRequiredMap[key] ? '105px' : '120px') :
                                            // j === 2 ? (checkBoxRequiredMap[key] ? '220px' : '160px') 
                                            'auto',
                                        zIndex: j < 2 ? 1 : 0
                                      }}
                                    >
                                      {editingIndex?.rowIndex === i + startIndex &&
                                        editingIndex?.colKey === col.key ? (
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={row?.[col.key] || ""}
                                          onChange={(e) =>
                                            handleEditableColumnChange(
                                              e,
                                              col.key,
                                              i + startIndex,
                                              row.ContactID
                                            )
                                          }
                                          onBlur={() => setEditingIndex(null)}
                                          autoFocus
                                        />
                                      ) : col.type === "Link" ? (
                                        <a
                                          style={{ cursor: "pointer" }}
                                          className="text-decoration-none"
                                          onClick={() => hanldeLinkColumn(col.key, row)}
                                          href={row.FilePath}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          {row?.[col.key]}
                                        </a>
                                      ) : col.key === "Employee" ? (
                                        <span>
                                        {row?.[col.key]}{" "}
                                        {row?.["onMLLeave"] === 1 && (
                                          <span
                                            style={{
                                              backgroundColor: "#f49f15", // dark gray / black
                                              color: "white",
                                              fontSize: "0.7rem",         // smaller text
                                              padding: "2px 6px",
                                              borderRadius: "4px",
                                              marginLeft: "5px",
                                              fontWeight: "bold",
                                              display: "inline-block",
                                              lineHeight: 1
                                            }}
                                          >ML
                                          </span>
                                        )}
                                      </span>
                                      ) : isNaN(row?.[col.key]) ? (
                                        row?.[col.key] || "-"
                                      ) : (
                                        Number(row?.[col.key]).toLocaleString("en-IN", {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })
                                      )}
                                    </td>
                                  </OverlayTrigger>
                                ))}
                              </tr>
                            ))}

                            {key === "Calculate Payroll" && (
                              <tr style={{ fontWeight: "bold", backgroundColor: "#f0f0f0" }}>
                                <td style={{
                                  width: "25px",
                                  textAlign: "center",
                                  position: 'sticky',
                                  left: 0,
                                  zIndex: 1,
                                  backgroundColor: '#f0f0f0'
                                }}></td>
                                <td style={{
                                  width: "80px",
                                  textAlign: "center",
                                  position: 'sticky',
                                  left: '25px',
                                  zIndex: 1,
                                  backgroundColor: '#f0f0f0'
                                }}>Count</td>
                                <td style={{
                                  width: "80px",
                                  textAlign: "center",
                                  position: 'sticky',
                                  left: '105px',
                                  zIndex: 1,
                                  backgroundColor: '#f0f0f0'
                                }}>
                                  {sortedData.length}
                                </td>
                                <td style={{ width: "80px", textAlign: "center" }}></td>
                                <td style={{ width: "80px", textAlign: "center" }}></td>
                                {formattedKeys.map(({ key }) => (
                                  <td
                                    className="text-end"
                                    key={key}
                                    style={{
                                      width: "80px",
                                      textAlign: "right",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    {Number(totals[key]).toLocaleString("en-IN", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </td>
                                ))}
                              </tr>
                            )}
                          </tbody>
                        ) : isApiStatus === undefined ? (
                          <tbody>
                            <tr>
                              <td
                                colSpan={
                                  columnHeaders.length + (checkBoxRequiredMap[key] ? 1 : 0)
                                }
                                className="text-center"
                              >
                                <div>
                                  <p>
                                    <FaSpinner className="spinner" />
                                    <br />
                                    Loading
                                  </p>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        ) : (
                          <tbody>
                            <tr>
                              <td
                                colSpan={
                                  columnHeaders.length + (checkBoxRequiredMap[key] ? 1 : 0)
                                }
                                className="text-center"
                              >
                                <p>No Data Found</p>
                              </td>
                            </tr>
                          </tbody>
                        )
                      )}
                    </Table>
                  </div>
                // </div>
              );
            })}
          </div>
        </div>

        {/* <div className="d-flex justify-content-between mb-3">
          <div>
            <span className="d-flex">
              Showing {(currentPage - 1) * selectedRecordsPerPage + 1} -{" "}
              {Math.min(currentPage * selectedRecordsPerPage, sortedData.length)}{" "}
              of {sortedData.length} <span className="ms-1">results</span>
              <select
                value={selectedRecordsPerPage}
                onChange={handleRecordsPerPage}
                className="mx-2 form-select-sm"
              >
                {recordsPerPageOption.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </span>
          </div>
          <div>
            <Pagination
              itemsPerPage={selectedRecordsPerPage}
              totalItems={sortedData.length}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default CalculatePayrollComponent;